export default __webpack_public_path__ + "static/media/basic-android.efe52d02.png";